import React from 'react'
import Scroller from './../scroller'
import { Col, Row, Container } from "react-bootstrap"
const Inicio = ({ id }) => {
    return (

        <header className="masthead" id={id}>
            <Container className="h-100">
                <Row className="h-100 align-items-center justify-content-center text-center">
                    <Col lg={11} className="align-self-end">
                        <h1 className="text-uppercase text-white font-weight-bold">
                            TOMA EL CONTROL DE TUS CESIONES
                        </h1>
                    </Col>
                    <Col lg={9} className="align-self-baseline">
                        <br />
                        <p >
                            Recibe notificaciones de todos los eventos que han tenido tus cesiones en el SII <br />
                            Obtén certificados de <b>cesión</b>, <b>anulación</b>, <b>reclamo</b> y más en un solo lugar<br />
                            <b>Mejora el tiempo de respuesta de tu equipo y optimiza tus procesos</b>
                        </p>
                        <a className="btn btn-outline-light  js-scroll-trigger" href="#sobre" onClick={Scroller.handleAnchorScroll}>
                            Saber más
                        </a>
                    </Col>
                </Row>
            </Container>
        </header>

    )
}

export default Inicio
